import * as types from './actionTypes';
import { beginAjaxCall, ajaxCallError } from './ajaxStatusActions';
import axios from 'axios';
import { baseApi } from '../constants/app';

export function loadSitesSuccess(sites) {
  return { type: types.LOAD_SITES_SUCCESS, sites };
}

export function createSiteSuccess(site) {
  return { type: types.CREATE_SITE_SUCCESS, site };
}

export function updateSiteSuccess(site) {
  return { type: types.UPDATE_SITE_SUCCESS, site };
}

export function deleteSiteSuccess(site) {
  return { type: types.DELETE_SITE_SUCCESS, site };
}

export function loadSites() {
  return function (dispatch) {
    dispatch(beginAjaxCall());
    let url = baseApi + 'sites';
    return axios
      .get(url)
      .then((response) => {
        dispatch(loadSitesSuccess(response.data));
      })
      .catch((error) => {
        dispatch(ajaxCallError(error));
        throw error;
      });
  };
}

export function saveSite(site) {
  return function (dispatch, getState) {
    dispatch(beginAjaxCall());
    let url = baseApi + 'sites';
    if (site.id) {
      url = baseApi + 'sites/' + site.id;
      return axios
        .put(url, {
          ...site,
        })
        .then((response) => {
          dispatch(updateSiteSuccess(response.data));
        })
        .catch((error) => {
          dispatch(ajaxCallError(error));
          throw error;
        });
    } else {
      return axios
        .post(url, {
          siteId: site.siteId,
          systemId: site.systemId,
          siteName: site.siteName,
          city: site.city,
          county: site.county,
          facilityDescription: site.facilityDescription || null,
          hasMaster: site.hasMaster || true,
          masterMultiplier: site.hasMaster ? site.masterMultiplier : 0,
          isActive: site.isActive || true,
        })
        .then((response) => {
          dispatch(createSiteSuccess(response.data));
        })
        .catch((error) => {
          dispatch(ajaxCallError(error));
          throw error;
        });
    }
  };
}

export function deleteSite(site) {
  return function (dispatch) {
    let url = baseApi + 'sites/' + site.id;
    return axios
      .delete(url)
      .then((response) => {
        dispatch(deleteSiteSuccess(response.data));
      })
      .catch((error) => {
        dispatch(ajaxCallError(error));
        throw error;
      });
  };
}



// WEBPACK FOOTER //
// ./src/actions/siteActions.js